<template>
  <a-modal v-model="showModal" class="modalContainer text-center p-4 discardModal" :footer="null" :closable="false" width="393px" :centered="true" :maskClosable="false">
    <h3 class="fw700 font32 gray700 text-center mt-4">Discard {{ type }}?</h3>
    <p class="my-4 gray500 text-center font16">If you close the window, your {{ type }} will be lost.</p>
    <div class="gap10 flex-center-center mb-5">
      <button class="p1224 br6 font14 fw700 cp bg-gray200 gray600" @click="hide">Cancel</button>
      <button class="p1224 br6 font14 fw700 cp font-white" :style="{ background: getPrimaryColor() }" @click="discard">Discard</button>
    </div>
  </a-modal>
</template>

<script>
export default {
  data() {
    return { showModal: false, type: "post" }
  },
  props: {
    discardPost: Function,
  },
  methods: {
    show(type = "post") {
      this.showModal = true
      this.type = type
    },
    hide() {
      this.showModal = false
    },
    discard() {
      this.hide()
      this.discardPost()
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  border: none;
}
@media screen and (max-width: 600px) {
  .gap10 {
    flex-direction: column;
    gap: 16px;
    button {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/activity/Discard.vue